[
    {
        "key": "1-1-1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 0,
                "y": 31,
                "key": "D7MtA"
            },
            {
                "x": 1,
                "y": 31,
                "key": "-e_-t"
            },
            {
                "x": 1,
                "y": 30,
                "key": "SGqJp"
            },
            {
                "x": 2,
                "y": 30,
                "key": "dEgTA"
            },
            {
                "x": 2,
                "y": 29,
                "key": "v8mHN"
            },
            {
                "x": 4,
                "y": 29,
                "key": "s94aR"
            },
            {
                "x": 4,
                "y": 30,
                "key": "1FvAc"
            },
            {
                "x": 5,
                "y": 30,
                "key": "DfFmi"
            },
            {
                "x": 6,
                "y": 30,
                "key": "kwTnh"
            },
            {
                "x": 6,
                "y": 32,
                "key": "t8rlH"
            },
            {
                "x": 6,
                "y": 33,
                "key": "ftdk5"
            },
            {
                "x": 5,
                "y": 33,
                "key": "dDZN0"
            },
            {
                "x": 5,
                "y": 34,
                "key": "A6RhE"
            },
            {
                "x": 5,
                "y": 34,
                "key": "uakCe"
            },
            {
                "x": 4,
                "y": 34,
                "key": "o5cJb"
            },
            {
                "x": 3,
                "y": 34,
                "key": "b1Yj_"
            },
            {
                "x": 3,
                "y": 34,
                "key": "EbnCt"
            },
            {
                "x": 2,
                "y": 34,
                "key": "HKpp0"
            },
            {
                "x": 1,
                "y": 34,
                "key": "DK_Ob"
            },
            {
                "x": 1,
                "y": 33,
                "key": "nF6T6"
            },
            {
                "x": 0,
                "y": 33,
                "key": "XC5hm"
            }
        ]
    },
    {
        "key": "1-1-2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 0,
                "y": 39,
                "key": "lME6j"
            },
            {
                "x": 0,
                "y": 37,
                "key": "zYwZ1"
            },
            {
                "x": 0,
                "y": 36,
                "key": "fplrk"
            },
            {
                "x": 1,
                "y": 36,
                "key": "mArih"
            },
            {
                "x": 2,
                "y": 36,
                "key": "SJNbz"
            },
            {
                "x": 2,
                "y": 35,
                "key": "i8_SQ"
            },
            {
                "x": 5,
                "y": 35,
                "key": "Su6D6"
            },
            {
                "x": 6,
                "y": 35,
                "key": "fFsdD"
            },
            {
                "x": 6,
                "y": 36,
                "key": "OE7dT"
            },
            {
                "x": 6,
                "y": 37,
                "key": "sd8f8"
            },
            {
                "x": 6,
                "y": 38,
                "key": "5cG9H"
            },
            {
                "x": 5,
                "y": 38,
                "key": "mdGCh"
            },
            {
                "x": 4,
                "y": 38,
                "key": "EZCt2"
            },
            {
                "x": 4,
                "y": 39,
                "key": "qFFgL"
            }
        ]
    },
    {
        "key": "1-1-3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 0,
                "y": 43,
                "key": "CMYwS"
            },
            {
                "x": 0,
                "y": 42,
                "key": "cSehn"
            },
            {
                "x": 0,
                "y": 41,
                "key": "T-cNL"
            },
            {
                "x": 1,
                "y": 41,
                "key": "w1I7T"
            },
            {
                "x": 1,
                "y": 40,
                "key": "cC5OJ"
            },
            {
                "x": 4,
                "y": 40,
                "key": "s9_sG"
            },
            {
                "x": 4,
                "y": 42,
                "key": "CV3uI"
            },
            {
                "x": 6,
                "y": 42,
                "key": "H6XyF"
            },
            {
                "x": 6,
                "y": 44,
                "key": "WUCzY"
            },
            {
                "x": 5,
                "y": 44,
                "key": "7proT"
            },
            {
                "x": 5,
                "y": 45,
                "key": "mZwT1"
            },
            {
                "x": 4,
                "y": 45,
                "key": "TSD5-"
            },
            {
                "x": 2,
                "y": 45,
                "key": "Z0uWr"
            },
            {
                "x": 2,
                "y": 43,
                "key": "PhYno"
            }
        ]
    },
    {
        "key": "1-3-1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 26,
                "y": 33,
                "key": "ZRMEY"
            },
            {
                "x": 26,
                "y": 31,
                "key": "a2Eaj"
            },
            {
                "x": 28,
                "y": 31,
                "key": "WPD3p"
            },
            {
                "x": 28,
                "y": 30,
                "key": "Ot0iU"
            },
            {
                "x": 31,
                "y": 30,
                "key": "XiSYL"
            },
            {
                "x": 31,
                "y": 31,
                "key": "SgGUq"
            },
            {
                "x": 32,
                "y": 31,
                "key": "VhmA1"
            },
            {
                "x": 32,
                "y": 32,
                "key": "A3D7F"
            },
            {
                "x": 33,
                "y": 32,
                "key": "eJYWr"
            },
            {
                "x": 33,
                "y": 34,
                "key": "_Ib9d"
            },
            {
                "x": 31,
                "y": 34,
                "key": "Fn7bW"
            },
            {
                "x": 31,
                "y": 35,
                "key": "v0wf4"
            },
            {
                "x": 28,
                "y": 35,
                "key": "OOahF"
            },
            {
                "x": 28,
                "y": 34,
                "key": "suWtV"
            },
            {
                "x": 27,
                "y": 34,
                "key": "y_8t9"
            },
            {
                "x": 27,
                "y": 33,
                "key": "Ve6mq"
            }
        ]
    },
    {
        "key": "1-3-2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 28,
                "y": 38,
                "key": "ktlgA"
            },
            {
                "x": 28,
                "y": 37,
                "key": "RZzsO"
            },
            {
                "x": 28,
                "y": 36,
                "key": "qWfXX"
            },
            {
                "x": 29,
                "y": 36,
                "key": "YZXja"
            },
            {
                "x": 30,
                "y": 36,
                "key": "j0sF-"
            },
            {
                "x": 30,
                "y": 38,
                "key": "Ea27S"
            },
            {
                "x": 32,
                "y": 38,
                "key": "oQnlq"
            },
            {
                "x": 32,
                "y": 40,
                "key": "cY2Nn"
            },
            {
                "x": 30,
                "y": 40,
                "key": "-WmAz"
            },
            {
                "x": 30,
                "y": 42,
                "key": "BxVqd"
            },
            {
                "x": 28,
                "y": 42,
                "key": "ksiKm"
            },
            {
                "x": 28,
                "y": 40,
                "key": "biry4"
            },
            {
                "x": 26,
                "y": 40,
                "key": "61SeZ"
            },
            {
                "x": 26,
                "y": 38,
                "key": "Lu1Ae"
            }
        ]
    },
    {
        "key": "1-3-3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 26,
                "y": 44,
                "key": "GcTxO"
            },
            {
                "x": 27,
                "y": 44,
                "key": "vMxQZ"
            },
            {
                "x": 27,
                "y": 43,
                "key": "r8_AU"
            },
            {
                "x": 29,
                "y": 43,
                "key": "ejTpa"
            },
            {
                "x": 30,
                "y": 43,
                "key": "2a-jK"
            },
            {
                "x": 30,
                "y": 44,
                "key": "_REz9"
            },
            {
                "x": 31,
                "y": 44,
                "key": "aVbNZ"
            },
            {
                "x": 32,
                "y": 44,
                "key": "dPhlD"
            },
            {
                "x": 32,
                "y": 46,
                "key": "24tN1"
            },
            {
                "x": 32,
                "y": 47,
                "key": "juKfm"
            },
            {
                "x": 31,
                "y": 47,
                "key": "BC0LF"
            },
            {
                "x": 30,
                "y": 47,
                "key": "Iggr4"
            },
            {
                "x": 30,
                "y": 48,
                "key": "4N7Zp"
            },
            {
                "x": 28,
                "y": 48,
                "key": "qwlfj"
            },
            {
                "x": 28,
                "y": 47,
                "key": "cpSZb"
            },
            {
                "x": 27,
                "y": 47,
                "key": "UcUlf"
            },
            {
                "x": 27,
                "y": 46,
                "key": "qG5M0"
            },
            {
                "x": 26,
                "y": 46,
                "key": "KrRli"
            }
        ]
    },
    {
        "key": "2-1-1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 42,
                "y": 34,
                "key": "WjMee"
            },
            {
                "x": 42,
                "y": 31,
                "key": "INt2V"
            },
            {
                "x": 43,
                "y": 31,
                "key": "INXDP"
            },
            {
                "x": 43,
                "y": 30,
                "key": "7Qg-O"
            },
            {
                "x": 46,
                "y": 30,
                "key": "_7QYs"
            },
            {
                "x": 46,
                "y": 31,
                "key": "fW-qx"
            },
            {
                "x": 47,
                "y": 31,
                "key": "Z3LnI"
            },
            {
                "x": 47,
                "y": 33,
                "key": "9LDlX"
            },
            {
                "x": 46,
                "y": 33,
                "key": "ky3-B"
            },
            {
                "x": 46,
                "y": 35,
                "key": "0mWas"
            },
            {
                "x": 43,
                "y": 35,
                "key": "e-nmk"
            },
            {
                "x": 43,
                "y": 34,
                "key": "weVrk"
            }
        ]
    },
    {
        "key": "2-1-2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 42,
                "y": 38,
                "key": "wstZB"
            },
            {
                "x": 43,
                "y": 38,
                "key": "w5_go"
            },
            {
                "x": 43,
                "y": 37,
                "key": "HKqY2"
            },
            {
                "x": 44,
                "y": 37,
                "key": "ogCZp"
            },
            {
                "x": 44,
                "y": 36,
                "key": "YIGSE"
            },
            {
                "x": 46,
                "y": 36,
                "key": "IIcdB"
            },
            {
                "x": 46,
                "y": 37,
                "key": "_HLPA"
            },
            {
                "x": 47,
                "y": 37,
                "key": "2iqp3"
            },
            {
                "x": 47,
                "y": 38,
                "key": "AulXa"
            },
            {
                "x": 48,
                "y": 38,
                "key": "v-0iM"
            },
            {
                "x": 48,
                "y": 40,
                "key": "5FmZo"
            },
            {
                "x": 47,
                "y": 40,
                "key": "vRswK"
            },
            {
                "x": 47,
                "y": 41,
                "key": "6Oiw8"
            },
            {
                "x": 46,
                "y": 41,
                "key": "MvMq6"
            },
            {
                "x": 46,
                "y": 42,
                "key": "BKMCN"
            },
            {
                "x": 44,
                "y": 42,
                "key": "7KeOi"
            },
            {
                "x": 44,
                "y": 41,
                "key": "ZYmXa"
            },
            {
                "x": 43,
                "y": 41,
                "key": "9yDto"
            },
            {
                "x": 43,
                "y": 40,
                "key": "xUu_m"
            },
            {
                "x": 42,
                "y": 40,
                "key": "zyZrO"
            }
        ]
    },
    {
        "key": "2-1-3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 42,
                "y": 47,
                "key": "EsaE9"
            },
            {
                "x": 42,
                "y": 45,
                "key": "0XE1F"
            },
            {
                "x": 43,
                "y": 45,
                "key": "vMPaq"
            },
            {
                "x": 43,
                "y": 44,
                "key": "RS8Jr"
            },
            {
                "x": 43,
                "y": 43,
                "key": "t3-2T"
            },
            {
                "x": 44,
                "y": 43,
                "key": "WqrxV"
            },
            {
                "x": 45,
                "y": 43,
                "key": "4mTaX"
            },
            {
                "x": 45,
                "y": 44,
                "key": "NNpkL"
            },
            {
                "x": 46,
                "y": 44,
                "key": "c0Os4"
            },
            {
                "x": 46,
                "y": 45,
                "key": "Mob5z"
            },
            {
                "x": 48,
                "y": 45,
                "key": "Xv3x-"
            },
            {
                "x": 48,
                "y": 46,
                "key": "1o7vp"
            },
            {
                "x": 48,
                "y": 47,
                "key": "krnYk"
            },
            {
                "x": 48,
                "y": 48,
                "key": "AjvDd"
            },
            {
                "x": 48,
                "y": 48,
                "key": "EK3kW"
            },
            {
                "x": 46,
                "y": 48,
                "key": "VRn4Q"
            },
            {
                "x": 46,
                "y": 49,
                "key": "Zx19y"
            },
            {
                "x": 43,
                "y": 49,
                "key": "yBBbI"
            },
            {
                "x": 43,
                "y": 48,
                "key": "Hjx6Y"
            },
            {
                "x": 42,
                "y": 48,
                "key": "8n6EU"
            }
        ]
    },
    {
        "key": "2-2-1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 55,
                "y": 31,
                "key": "CNas_"
            },
            {
                "x": 56,
                "y": 31,
                "key": "5tMeG"
            },
            {
                "x": 56,
                "y": 30,
                "key": "jA3kd"
            },
            {
                "x": 61,
                "y": 30,
                "key": "dKEDh"
            },
            {
                "x": 61,
                "y": 32,
                "key": "zWu2d"
            },
            {
                "x": 60,
                "y": 32,
                "key": "FbgWx"
            },
            {
                "x": 60,
                "y": 33,
                "key": "4ab2_"
            },
            {
                "x": 61,
                "y": 33,
                "key": "845JN"
            },
            {
                "x": 61,
                "y": 35,
                "key": "B1SB3"
            },
            {
                "x": 56,
                "y": 35,
                "key": "k4So7"
            },
            {
                "x": 56,
                "y": 34,
                "key": "DxQba"
            },
            {
                "x": 55,
                "y": 34,
                "key": "fiv32"
            }
        ]
    },
    {
        "key": "2-2-2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 54,
                "y": 37,
                "key": "QrEBh"
            },
            {
                "x": 55,
                "y": 37,
                "key": "X1Dfh"
            },
            {
                "x": 55,
                "y": 36,
                "key": "hJ0Fx"
            },
            {
                "x": 60,
                "y": 36,
                "key": "crHlz"
            },
            {
                "x": 60,
                "y": 37,
                "key": "DlF_t"
            },
            {
                "x": 61,
                "y": 37,
                "key": "2njFJ"
            },
            {
                "x": 61,
                "y": 39,
                "key": "0R0iu"
            },
            {
                "x": 60,
                "y": 39,
                "key": "8fdy-"
            },
            {
                "x": 60,
                "y": 40,
                "key": "UtMqE"
            },
            {
                "x": 55,
                "y": 40,
                "key": "8QSmq"
            },
            {
                "x": 55,
                "y": 39,
                "key": "P1UCc"
            },
            {
                "x": 54,
                "y": 39,
                "key": "HeawA"
            }
        ]
    },
    {
        "key": "2-2-3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 55,
                "y": 45,
                "key": "ZakfZ"
            },
            {
                "x": 55,
                "y": 42,
                "key": "D3Qdo"
            },
            {
                "x": 56,
                "y": 42,
                "key": "NsCkR"
            },
            {
                "x": 56,
                "y": 41,
                "key": "Iu2_t"
            },
            {
                "x": 59,
                "y": 41,
                "key": "IUD0u"
            },
            {
                "x": 59,
                "y": 43,
                "key": "0xfOs"
            },
            {
                "x": 61,
                "y": 43,
                "key": "iyB1-"
            },
            {
                "x": 61,
                "y": 45,
                "key": "bs1dY"
            },
            {
                "x": 60,
                "y": 45,
                "key": "Alvx1"
            },
            {
                "x": 60,
                "y": 46,
                "key": "kRZni"
            },
            {
                "x": 56,
                "y": 46,
                "key": "w_ZXZ"
            },
            {
                "x": 56,
                "y": 45,
                "key": "ubSFE"
            }
        ]
    },
    {
        "key": "2-3-1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 71,
                "y": 34,
                "key": "QK_Lz"
            },
            {
                "x": 71,
                "y": 30,
                "key": "bOTOr"
            },
            {
                "x": 73,
                "y": 30,
                "key": "p8KHn"
            },
            {
                "x": 73,
                "y": 31,
                "key": "NectH"
            },
            {
                "x": 75,
                "y": 31,
                "key": "qtk9I"
            },
            {
                "x": 75,
                "y": 30,
                "key": "3Yf7C"
            },
            {
                "x": 77,
                "y": 30,
                "key": "Nejpf"
            },
            {
                "x": 77,
                "y": 34,
                "key": "B6iID"
            },
            {
                "x": 76,
                "y": 34,
                "key": "zgK8i"
            },
            {
                "x": 76,
                "y": 35,
                "key": "-glNg"
            },
            {
                "x": 72,
                "y": 35,
                "key": "AeUtz"
            },
            {
                "x": 72,
                "y": 34,
                "key": "fgQXb"
            }
        ]
    },
    {
        "key": "2-3-2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 71,
                "y": 38,
                "key": "_Jl_k"
            },
            {
                "x": 72,
                "y": 38,
                "key": "EiWlz"
            },
            {
                "x": 72,
                "y": 37,
                "key": "A8YgB"
            },
            {
                "x": 73,
                "y": 37,
                "key": "J5bAW"
            },
            {
                "x": 73,
                "y": 36,
                "key": "M-dh0"
            },
            {
                "x": 75,
                "y": 36,
                "key": "5cxtQ"
            },
            {
                "x": 75,
                "y": 37,
                "key": "82N2Y"
            },
            {
                "x": 76,
                "y": 37,
                "key": "Oz3g9"
            },
            {
                "x": 76,
                "y": 38,
                "key": "XZrWx"
            },
            {
                "x": 77,
                "y": 38,
                "key": "aw_ek"
            },
            {
                "x": 77,
                "y": 41,
                "key": "Iz8bW"
            },
            {
                "x": 72,
                "y": 41,
                "key": "H1w5J"
            },
            {
                "x": 72,
                "y": 40,
                "key": "ydOlE"
            },
            {
                "x": 71,
                "y": 40,
                "key": "g-P8w"
            }
        ]
    },
    {
        "key": "2-3-3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 72,
                "y": 47,
                "key": "Zr2Lu"
            },
            {
                "x": 72,
                "y": 43,
                "key": "PteoA"
            },
            {
                "x": 73,
                "y": 43,
                "key": "yHIbD"
            },
            {
                "x": 73,
                "y": 42,
                "key": "fm0ln"
            },
            {
                "x": 76,
                "y": 42,
                "key": "VGiEk"
            },
            {
                "x": 76,
                "y": 43,
                "key": "MN57E"
            },
            {
                "x": 77,
                "y": 43,
                "key": "qa3wX"
            },
            {
                "x": 77,
                "y": 46,
                "key": "FK-Zp"
            },
            {
                "x": 76,
                "y": 46,
                "key": "kL4A8"
            },
            {
                "x": 76,
                "y": 48,
                "key": "dRm9M"
            },
            {
                "x": 73,
                "y": 48,
                "key": "JP97k"
            },
            {
                "x": 73,
                "y": 47,
                "key": "XHsTI"
            }
        ]
    },
    {
        "key": "2-4-1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 86,
                "y": 32,
                "key": "Ch4Uq"
            },
            {
                "x": 87,
                "y": 32,
                "key": "tP9d3"
            },
            {
                "x": 87,
                "y": 30,
                "key": "HuW8U"
            },
            {
                "x": 89,
                "y": 30,
                "key": "aoArJ"
            },
            {
                "x": 89,
                "y": 29,
                "key": "aYzlz"
            },
            {
                "x": 92,
                "y": 29,
                "key": "7k-7O"
            },
            {
                "x": 92,
                "y": 34,
                "key": "WWELW"
            },
            {
                "x": 91,
                "y": 34,
                "key": "WVANM"
            },
            {
                "x": 91,
                "y": 35,
                "key": "Cq4UN"
            },
            {
                "x": 86,
                "y": 35,
                "key": "ZO7yr"
            }
        ]
    },
    {
        "key": "2-4-2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 87,
                "y": 41,
                "key": "AhIsc"
            },
            {
                "x": 86,
                "y": 41,
                "key": "fX0jI"
            },
            {
                "x": 86,
                "y": 40,
                "key": "hbOI-"
            },
            {
                "x": 87,
                "y": 40,
                "key": "IIxKt"
            },
            {
                "x": 87,
                "y": 38,
                "key": "J0MQE"
            },
            {
                "x": 86,
                "y": 38,
                "key": "DeR4K"
            },
            {
                "x": 86,
                "y": 37,
                "key": "yI1RC"
            },
            {
                "x": 87,
                "y": 37,
                "key": "zCt0O"
            },
            {
                "x": 87,
                "y": 36,
                "key": "IAMoh"
            },
            {
                "x": 91,
                "y": 36,
                "key": "2Ckzv"
            },
            {
                "x": 91,
                "y": 37,
                "key": "XHrp5"
            },
            {
                "x": 92,
                "y": 37,
                "key": "L9ELJ"
            },
            {
                "x": 92,
                "y": 39,
                "key": "dwZzl"
            },
            {
                "x": 92,
                "y": 41,
                "key": "LMOHl"
            },
            {
                "x": 89,
                "y": 41,
                "key": "s2v4l"
            }
        ]
    },
    {
        "key": "2-4-3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 87,
                "y": 47,
                "key": "FvRh2"
            },
            {
                "x": 87,
                "y": 42,
                "key": "8WADC"
            },
            {
                "x": 91,
                "y": 42,
                "key": "nL3g_"
            },
            {
                "x": 91,
                "y": 43,
                "key": "ff9LN"
            },
            {
                "x": 92,
                "y": 43,
                "key": "HamVJ"
            },
            {
                "x": 92,
                "y": 48,
                "key": "ng5Dc"
            },
            {
                "x": 88,
                "y": 48,
                "key": "zYlrn"
            },
            {
                "x": 88,
                "y": 47,
                "key": "G2RPe"
            }
        ]
    },
    {
        "key": "3-1-1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 99,
                "y": 29,
                "key": "0Ngky"
            },
            {
                "x": 103,
                "y": 29,
                "key": "orORr"
            },
            {
                "x": 103,
                "y": 33,
                "key": "V8p35"
            },
            {
                "x": 99,
                "y": 33,
                "key": "DPDDI"
            }
        ]
    },
    {
        "key": "3-1-2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 99,
                "y": 34,
                "key": "vVrW2"
            },
            {
                "x": 103,
                "y": 34,
                "key": "5ZgQL"
            },
            {
                "x": 103,
                "y": 39,
                "key": "EKDnI"
            },
            {
                "x": 99,
                "y": 39,
                "key": "YfWlx"
            }
        ]
    },
    {
        "key": "3-1-3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 99,
                "y": 40,
                "key": "9SPJc"
            },
            {
                "x": 103,
                "y": 40,
                "key": "tPxe9"
            },
            {
                "x": 103,
                "y": 46,
                "key": "RjvxE"
            },
            {
                "x": 99,
                "y": 46,
                "key": "0Ivau"
            }
        ]
    },
    {
        "key": "3-3-1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 113,
                "y": 33,
                "key": "m3OKF"
            },
            {
                "x": 112,
                "y": 33,
                "key": "CkRP8"
            },
            {
                "x": 112,
                "y": 30,
                "key": "FzqM9"
            },
            {
                "x": 114,
                "y": 30,
                "key": "irTRK"
            },
            {
                "x": 114,
                "y": 29,
                "key": "BV0Yl"
            },
            {
                "x": 117,
                "y": 29,
                "key": "5XCSn"
            },
            {
                "x": 117,
                "y": 30,
                "key": "M9vvg"
            },
            {
                "x": 119,
                "y": 30,
                "key": "1cF-_"
            },
            {
                "x": 119,
                "y": 32,
                "key": "TY7Lp"
            },
            {
                "x": 118,
                "y": 32,
                "key": "0-Yhl"
            },
            {
                "x": 118,
                "y": 33,
                "key": "QIRqm"
            },
            {
                "x": 117,
                "y": 33,
                "key": "2vqYW"
            },
            {
                "x": 117,
                "y": 34,
                "key": "_PklU"
            },
            {
                "x": 113,
                "y": 34,
                "key": "nW6v_"
            }
        ]
    },
    {
        "key": "3-3-2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 112,
                "y": 40,
                "key": "_uWbU"
            },
            {
                "x": 112,
                "y": 39,
                "key": "cQ0Fd"
            },
            {
                "x": 113,
                "y": 39,
                "key": "lD3kk"
            },
            {
                "x": 113,
                "y": 37,
                "key": "Sb-F8"
            },
            {
                "x": 112,
                "y": 37,
                "key": "qW9Ow"
            },
            {
                "x": 112,
                "y": 36,
                "key": "OadNI"
            },
            {
                "x": 114,
                "y": 36,
                "key": "0x0rQ"
            },
            {
                "x": 114,
                "y": 35,
                "key": "kKPYH"
            },
            {
                "x": 116,
                "y": 35,
                "key": "86tqE"
            },
            {
                "x": 116,
                "y": 36,
                "key": "66eqm"
            },
            {
                "x": 117,
                "y": 36,
                "key": "25dVf"
            },
            {
                "x": 117,
                "y": 37,
                "key": "ECDfl"
            },
            {
                "x": 119,
                "y": 37,
                "key": "L7otc"
            },
            {
                "x": 119,
                "y": 40,
                "key": "nLrml"
            },
            {
                "x": 117,
                "y": 40,
                "key": "2gOI-"
            },
            {
                "x": 117,
                "y": 41,
                "key": "EBHBn"
            },
            {
                "x": 114,
                "y": 41,
                "key": "M-reV"
            },
            {
                "x": 114,
                "y": 40,
                "key": "7yElO"
            }
        ]
    },
    {
        "key": "3-3-3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 112,
                "y": 44,
                "key": "Lm1bE"
            },
            {
                "x": 113,
                "y": 44,
                "key": "TLNGP"
            },
            {
                "x": 113,
                "y": 43,
                "key": "qBSty"
            },
            {
                "x": 114,
                "y": 43,
                "key": "HA_Dd"
            },
            {
                "x": 114,
                "y": 42,
                "key": "yY5M6"
            },
            {
                "x": 116,
                "y": 42,
                "key": "OD7Vu"
            },
            {
                "x": 116,
                "y": 43,
                "key": "-5hxj"
            },
            {
                "x": 118,
                "y": 43,
                "key": "LUMdF"
            },
            {
                "x": 118,
                "y": 45,
                "key": "pMMBX"
            },
            {
                "x": 118,
                "y": 46,
                "key": "g5DOD"
            },
            {
                "x": 116,
                "y": 46,
                "key": "PzsOl"
            },
            {
                "x": 116,
                "y": 47,
                "key": "k2UIc"
            },
            {
                "x": 114,
                "y": 47,
                "key": "HEJWI"
            },
            {
                "x": 114,
                "y": 46,
                "key": "LvUB0"
            },
            {
                "x": 112,
                "y": 46,
                "key": "b8-I3"
            }
        ]
    },
    {
        "key": "2-5-1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 128,
                "y": 31,
                "key": "jSuTo"
            },
            {
                "x": 129,
                "y": 31,
                "key": "r6KKL"
            },
            {
                "x": 129,
                "y": 29,
                "key": "Q62oD"
            },
            {
                "x": 132,
                "y": 29,
                "key": "iRDBc"
            },
            {
                "x": 132,
                "y": 30,
                "key": "pQ5_F"
            },
            {
                "x": 133,
                "y": 30,
                "key": "U3Cid"
            },
            {
                "x": 133,
                "y": 31,
                "key": "6yGp5"
            },
            {
                "x": 134,
                "y": 31,
                "key": "8qAGv"
            },
            {
                "x": 134,
                "y": 34,
                "key": "MymcM"
            },
            {
                "x": 133,
                "y": 34,
                "key": "XF_x8"
            },
            {
                "x": 132,
                "y": 34,
                "key": "mf6pd"
            },
            {
                "x": 132,
                "y": 34,
                "key": "xjpss"
            },
            {
                "x": 132,
                "y": 33,
                "key": "a3D4Z"
            },
            {
                "x": 130,
                "y": 33,
                "key": "_i1fk"
            },
            {
                "x": 130,
                "y": 34,
                "key": "HZD0e"
            },
            {
                "x": 128,
                "y": 34,
                "key": "9l_2t"
            }
        ]
    },
    {
        "key": "2-5-2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 128,
                "y": 39,
                "key": "WUQvD"
            },
            {
                "x": 128,
                "y": 36,
                "key": "3rsLf"
            },
            {
                "x": 129,
                "y": 36,
                "key": "-yRPc"
            },
            {
                "x": 129,
                "y": 36,
                "key": "ReRz7"
            },
            {
                "x": 129,
                "y": 35,
                "key": "AXCEp"
            },
            {
                "x": 130,
                "y": 35,
                "key": "-co6t"
            },
            {
                "x": 131,
                "y": 35,
                "key": "QESkR"
            },
            {
                "x": 131,
                "y": 36,
                "key": "-if_j"
            },
            {
                "x": 132,
                "y": 36,
                "key": "qEitt"
            },
            {
                "x": 132,
                "y": 35,
                "key": "MLZBG"
            },
            {
                "x": 133,
                "y": 35,
                "key": "-0zel"
            },
            {
                "x": 134,
                "y": 35,
                "key": "DtKg0"
            },
            {
                "x": 134,
                "y": 36,
                "key": "WXSTc"
            },
            {
                "x": 135,
                "y": 36,
                "key": "kvCNJ"
            },
            {
                "x": 135,
                "y": 36,
                "key": "XlfaT"
            },
            {
                "x": 135,
                "y": 39,
                "key": "35j-C"
            },
            {
                "x": 134,
                "y": 39,
                "key": "Fzze0"
            },
            {
                "x": 134,
                "y": 40,
                "key": "sNE_u"
            },
            {
                "x": 132,
                "y": 40,
                "key": "kZojD"
            },
            {
                "x": 132,
                "y": 39,
                "key": "nyL5i"
            },
            {
                "x": 131,
                "y": 39,
                "key": "3_5w8"
            },
            {
                "x": 131,
                "y": 40,
                "key": "2kOBm"
            },
            {
                "x": 129,
                "y": 40,
                "key": "O_TXE"
            },
            {
                "x": 129,
                "y": 39,
                "key": "gEo6V"
            },
            {
                "x": 129,
                "y": 39,
                "key": "NCP4J"
            }
        ]
    },
    {
        "key": "2-5-3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 128,
                "y": 46,
                "key": "3vOn_"
            },
            {
                "x": 128,
                "y": 45,
                "key": "2ZE8k"
            },
            {
                "x": 129,
                "y": 45,
                "key": "XIXsW"
            },
            {
                "x": 129,
                "y": 44,
                "key": "a2F03"
            },
            {
                "x": 128,
                "y": 44,
                "key": "eM7j5"
            },
            {
                "x": 128,
                "y": 42,
                "key": "ixvNn"
            },
            {
                "x": 129,
                "y": 42,
                "key": "fa_0j"
            },
            {
                "x": 129,
                "y": 41,
                "key": "mw1hG"
            },
            {
                "x": 133,
                "y": 41,
                "key": "u7WhB"
            },
            {
                "x": 133,
                "y": 42,
                "key": "csPdu"
            },
            {
                "x": 134,
                "y": 42,
                "key": "sQnY7"
            },
            {
                "x": 134,
                "y": 43,
                "key": "uncx9"
            },
            {
                "x": 133,
                "y": 43,
                "key": "RkadQ"
            },
            {
                "x": 133,
                "y": 44,
                "key": "T-xEm"
            },
            {
                "x": 134,
                "y": 44,
                "key": "30Q37"
            },
            {
                "x": 134,
                "y": 46,
                "key": "K9eNY"
            },
            {
                "x": 134,
                "y": 46,
                "key": "zmKe-"
            },
            {
                "x": 133,
                "y": 46,
                "key": "tkyd9"
            },
            {
                "x": 133,
                "y": 47,
                "key": "OnLxk"
            },
            {
                "x": 129,
                "y": 47,
                "key": "ECBt_"
            },
            {
                "x": 129,
                "y": 46,
                "key": "_xiC2"
            }
        ]
    },
    {
        "key": "camp",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 23,
                "y": 25,
                "key": "evfdJ"
            },
            {
                "x": 23,
                "y": 22,
                "key": "1YooM"
            },
            {
                "x": 24,
                "y": 22,
                "key": "clA79"
            },
            {
                "x": 24,
                "y": 21,
                "key": "bwXpS"
            },
            {
                "x": 29,
                "y": 21,
                "key": "bXZIW"
            },
            {
                "x": 29,
                "y": 22,
                "key": "OA-x2"
            },
            {
                "x": 30,
                "y": 22,
                "key": "4WjW-"
            },
            {
                "x": 30,
                "y": 25,
                "key": "tkuyG"
            },
            {
                "x": 29,
                "y": 25,
                "key": "UxIUM"
            },
            {
                "x": 29,
                "y": 26,
                "key": "CBnuQ"
            },
            {
                "x": 24,
                "y": 26,
                "key": "vsPXh"
            },
            {
                "x": 24,
                "y": 25,
                "key": "gqA7p"
            }
        ]
    },
    {
        "key": "1-2-1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 12,
                "y": 33,
                "key": "H1WJU"
            },
            {
                "x": 11,
                "y": 33,
                "key": "2yA90"
            },
            {
                "x": 11,
                "y": 31,
                "key": "ttq6o"
            },
            {
                "x": 12,
                "y": 31,
                "key": "3kZgP"
            },
            {
                "x": 12,
                "y": 30,
                "key": "EmpVQ"
            },
            {
                "x": 15,
                "y": 30,
                "key": "JSivm"
            },
            {
                "x": 17,
                "y": 30,
                "key": "klotO"
            },
            {
                "x": 17,
                "y": 34,
                "key": "t91DT"
            },
            {
                "x": 12,
                "y": 34,
                "key": "kEhyA"
            }
        ]
    },
    {
        "key": "1-2-2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 12,
                "y": 37,
                "key": "SHdAY"
            },
            {
                "x": 13,
                "y": 37,
                "key": "gFLpJ"
            },
            {
                "x": 13,
                "y": 36,
                "key": "V2K5u"
            },
            {
                "x": 14,
                "y": 36,
                "key": "kMsbm"
            },
            {
                "x": 14,
                "y": 35,
                "key": "hTVca"
            },
            {
                "x": 16,
                "y": 35,
                "key": "Ud1jU"
            },
            {
                "x": 16,
                "y": 36,
                "key": "B3MOy"
            },
            {
                "x": 17,
                "y": 36,
                "key": "NtIg1"
            },
            {
                "x": 17,
                "y": 37,
                "key": "GarFo"
            },
            {
                "x": 17,
                "y": 37,
                "key": "UohWP"
            },
            {
                "x": 17,
                "y": 39,
                "key": "fX1za"
            },
            {
                "x": 12,
                "y": 39,
                "key": "wJJyf"
            }
        ]
    },
    {
        "key": "1-2-3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 12,
                "y": 42,
                "key": "Jl3Ek"
            },
            {
                "x": 13,
                "y": 42,
                "key": "K08IV"
            },
            {
                "x": 13,
                "y": 41,
                "key": "jtYNz"
            },
            {
                "x": 14,
                "y": 41,
                "key": "vpnbc"
            },
            {
                "x": 14,
                "y": 40,
                "key": "KzW5T"
            },
            {
                "x": 17,
                "y": 40,
                "key": "qkHQf"
            },
            {
                "x": 17,
                "y": 41,
                "key": "QQntX"
            },
            {
                "x": 17,
                "y": 44,
                "key": "HujJQ"
            },
            {
                "x": 17,
                "y": 46,
                "key": "Y93NB"
            },
            {
                "x": 14,
                "y": 46,
                "key": "qzhyh"
            },
            {
                "x": 14,
                "y": 45,
                "key": "8erkG"
            },
            {
                "x": 13,
                "y": 45,
                "key": "gbuq-"
            },
            {
                "x": 13,
                "y": 44,
                "key": "6mJN7"
            },
            {
                "x": 12,
                "y": 44,
                "key": "qb7b-"
            }
        ]
    }
]